import { Modal } from "react-bootstrap";

function SwitchingDriverConfirmationModal({
  show,
  onClose,
  confirmSwitchDriver,
  orderTerminology,
  positionTerminology,
}) {
  const orderTermLowerCase = orderTerminology?.toLowerCase();
  const positionTermLowerCase = positionTerminology?.toLowerCase();
  return (
    <Modal show={show} onHide={onClose} backdrop="static" size="md">
      <Modal.Header>
        <Modal.Title>
          Switching {orderTerminology} Between {positionTerminology}s
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="pr-3">
          When switching submitted {orderTermLowerCase}s between{" "}
          {positionTermLowerCase}s, your changes{" "}
          <span className="font-600">WILL NOT</span> be finalized until you
          submit the new {positionTermLowerCase} you switched the{" "}
          {orderTermLowerCase} to. Submitting changes for the original{" "}
          {positionTermLowerCase} will also be disabled until you do so.
          <br />
          <br />
          You will be switched to the {positionTermLowerCase} you are assigning
          the {orderTermLowerCase} to.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={confirmSwitchDriver}
        >
          I Understand
        </button>
      </Modal.Footer>
    </Modal>
  );
}
export default SwitchingDriverConfirmationModal;
